import React, { FC, PropsWithChildren, useEffect, useState } from 'react';

import { Box } from '@rbilabs/universal-components';

import { APP_MINIMUM_HEIGHT } from 'utils/constants';

export const Wrapper: FC<PropsWithChildren> = ({ children }) => {
  const [windowHeight, setWindowHeight] = useState(
    Math.max(window.document.documentElement.clientHeight, APP_MINIMUM_HEIGHT)
  );
  useEffect(() => {
    function handleResize() {
      setWindowHeight(Math.max(window.document.documentElement.clientHeight, APP_MINIMUM_HEIGHT));
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <Box backgroundColor={Styles.color.background} height={windowHeight}>
      {children}
    </Box>
  );
};
